'use client';

import React from 'react';

import { Box, BoxProps } from './box';

export interface FlexProps extends BoxProps {
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  wrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  align?: 'start' | 'center' | 'end' | 'stretch' | 'baseline';
  justify?: 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly';
  gap?: number | string;
  rowGap?: number | string;
  columnGap?: number | string;
}

export const Flex = React.forwardRef<HTMLDivElement, FlexProps>(
  (
    { direction = 'row', wrap = 'nowrap', align, justify, gap, rowGap, columnGap, ...props },
    ref
  ) => {
    return (
      <Box
        ref={ref}
        display="flex"
        flexDirection={direction}
        flexWrap={wrap}
        alignItems={align}
        justifyContent={justify}
        gap={gap}
        rowGap={rowGap}
        columnGap={columnGap}
        {...props}
      />
    );
  }
);

Flex.displayName = 'Flex';
